<div class="pr-3 pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Thông báo&nbsp;</span><breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Thêm"
          nzTooltipPlacement="bottom" nz-tooltip (click)="Add()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button class="flex items-center justify-center" nz-button (click)="Add()">Thêm
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button class="flex items-center justify-center" nz-button (click)="Add()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          Thêm
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">

      <!-- <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Tỉnh thành</nz-form-label>
          <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
            [placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Đơn vị trực thuộc</nz-form-label>
          <asc-autocomplete [ascModel]="SoGDControl" (ascModelChange)="changeSoGD($event)"
            [placeholder]="'Chọn đơn vị trực thuộc...'" [getListAC]="getSoGDACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
          <asc-autocomplete [ascModel]="schoolControl" (ascModelChange)="changeSchool($event)"
            [placeholder]="'Chọn cơ sở...'" [getListAC]="getSchoolACFn"></asc-autocomplete>
        </nz-form-item>
      </div>  -->

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Tiêu đề</nz-form-label>
          <nz-form-control nzSpan="24" >
            <input nz-input  type="text" placeholder="Nhập tiêu đề" [jAutofocus] [(ngModel)]="commonFilter.Title" [ngModelOptions]="{standalone: true}">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Ngày bắt đầu</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-date-picker [nzFormat]="'dd/MM/yyyy'"  [(ngModel)]="commonFilter.FromDate" [ngModelOptions]="{standalone: true}"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>



      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Ngày hết hạn</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-date-picker [nzFormat]="'dd/MM/yyyy'" [(ngModel)]="commonFilter.ToDate" [ngModelOptions]="{standalone: true}"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="email">Trạng thái thông báo</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Trạng thái thông báo" [(ngModel)]="commonFilter.ExpirationStatus" [ngModelOptions]="{standalone: true}">
              <nz-option [nzValue]="0" nzLabel="Tất cả"></nz-option>
              <nz-option [nzValue]="1" nzLabel="Còn hạn"></nz-option>
              <nz-option [nzValue]="2" nzLabel="Hết hạn"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="email">Trạng thái</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Trạng thái" [(ngModel)]="commonFilter.ViewStatus" [ngModelOptions]="{standalone: true}">
              <nz-option [nzValue]="0" nzLabel="Tất cả"></nz-option>
              <nz-option [nzValue]="1" nzLabel="Chưa xem"></nz-option>
              <nz-option [nzValue]="2" nzLabel="Đã xem"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item >
      </div>


      <div nz-col nzSm="24" nzMd="12" nzLg="18" nzXl="18">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Đối tượng:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="commonFilter.AnnounceType" [ngModelOptions]="{standalone: true}">
              <label nz-radio  [nzValue]="1">đơn vị quản lý cấp Tỉnh/thành phố</label>
              <label nz-radio [nzValue]="2" >Cơ sở</label>
              <label nz-radio [nzValue]="3">Nhân sự</label>
              <label nz-radio [nzValue]="0">Tất cả</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip>Xóa tìm kiếm</button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
        nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table
      [nzShowTotal]="rangeTemplate"
      #Table nzOuterBordered nzShowSizeChanger [nzData]="dataList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)" [nzShowTotal]="rangeTemplate">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft>STT</th>
          <th nzLeft>Tiêu đề</th>
          <th nzWidth="95px">Ngày bắt đầu</th>
          <th nzWidth="95px">Ngày hết hạn</th>
          <th class="text-center"   nzWidth="70px">Đã xem</th>
          <th class="text-center"  nzWidth="70px">Chưa xem</th>
          <th nzWidth="115px">Người tạo</th>
          <th nzRight nzWidth="60px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td class="text-hidden" nzTooltipTitle="{{data.title}}" nzTooltipPlacement="top" nz-tooltip style="cursor: pointer" nzLeft (click)="showXemNoiDungThongBao(data)">{{ data.title }}</td>
          <td>{{ data.startDate | date:'dd/MM/yyyy'}}</td>
          <td>{{ data.expirationDate | date:'dd/MM/yyyy'}}</td>
          <td class="text-center" style="cursor:pointer" (click)="showPopupView(data.id)"><strong>{{ data.viewCount }}</strong></td>
          <td class="text-center" style="cursor:pointer" (click)="showPopupUnView(data.id)"><strong>{{ data.unViewedCount }}</strong></td>
          <td class="text-hidden" nzTooltipTitle="{{data.educationAndTrainingName}}" nzTooltipPlacement="top" nz-tooltip>{{ data.educationAndTrainingName}}</td>
          <td nzRight >
            <div nz-space nzAlign="end" class="space-align-block">
              <nz-space-item>
                <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip (click)="Edit(data)">
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </nz-space-item>
              <nz-space-item>
                <a class="text-red-600" nzTooltipTitle="Xóa" nzTooltipPlacement="top" nz-tooltip
                  (click)="showDelete(data)">
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </a>
              </nz-space-item>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>{{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
